module.exports = __webpack_public_path__ + "img/dbe0bb1.jpg";